import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Badge, Button, IconGraphy, Typography, colors } from '@leapeasy/ui-kit';
import { useDemoMask } from 'hooks/useDemoMask';
import { TreeViewer } from './TreeViewer';

const ANIMATION_MS = 240;

export const EditTreeViewModal = ({
  open,
  onClose,
  onSave,
  treeRecord,
  onMovesChange,
  loading,
}) => {
  const { mask } = useDemoMask();
  const [mounted, setMounted] = useState(open);
  const [isVisible, setIsVisible] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setTimeout(() => setIsVisible(true), 0);
      return;
    }

    if (mounted) {
      setIsVisible(false);
      const timer = setTimeout(() => setMounted(false), ANIMATION_MS);
      return () => clearTimeout(timer);
    }
  }, [open, mounted]);

  if (!mounted) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 999,
        display: 'flex',
        justifyContent: 'flex-end',
        backgroundColor: isVisible ? 'rgba(60, 57, 61, 0.35)' : 'rgba(60, 57, 61, 0)',
        transition: `background-color ${ANIMATION_MS}ms ease`,
      }}
    >
      <Box
        sx={{
          width: '460px',
          height: '100vh',
          maxHeight: '100dvh',
          overflow: 'hidden',
          boxSizing: 'border-box',
          backgroundColor: 'white',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
          transition: `transform ${ANIMATION_MS}ms ease`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '12px',
            borderBottom: '1px solid #EAEAEA',
            marginBottom: '20px',
          }}
        >
          <Typography variant="h4" style={{ color: colors.purple[900], fontWeight: 600 }}>
            Edit Tree view
          </Typography>
          <IconGraphy icon="General.Clear" onClick={onClose} style={{ cursor: 'pointer' }} />
        </Box>

        <Box sx={{ overflow: 'auto', flex: 1, minHeight: 0, paddingBottom: '12px' }}>
          <Box
            sx={{
              border: '1px solid #EAEAEA',
              borderRadius: '8px',
              padding: '12px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '12px',
            }}
          >
            <Badge
              background="#F3F1F4"
              color="warmBlue"
              label={treeRecord?.rootLabel || 'Operator'}
              textSize="Large"
              rounded
            />
            <Typography variant="body1" style={{ color: colors.neutral[900], fontWeight: 400 }}>
              {mask('email', treeRecord?.email || '')}
            </Typography>
          </Box>

          <Box sx={{ border: '1px solid #EAEAEA', borderRadius: '8px', marginBottom: '20px' }}>
            <TreeViewer treeRecord={treeRecord} onMovesChange={onMovesChange} isEditMode />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
            marginTop: 'auto',
            paddingTop: '12px',
            borderTop: '1px solid #EAEAEA',
            backgroundColor: 'white',
          }}
        >
          <Button variant="secondary" onClick={onClose}>
            Discard
          </Button>
          <Button variant="primary" onClick={onSave} disabled={loading}>
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
